import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { getDownloadURL, ref as storageRef } from "firebase/storage";

import { useAuth } from "../../../context/AuthContext";
import swal from "sweetalert";
import {
  getDocs,
  collection,
  query,
  orderBy,
  where,
} from "firebase/firestore";
import { functions, db, storage } from "../../../firebase";

import {
  startSetFiles,
  startRemoveFile,
  startAddFile,
} from "../../../actions/productFiles";

import { httpsCallable } from "firebase/functions";
import selectFiles from "../../../selectors/productFiles";
import { notifyWarning, notifyError } from "../toast/SetToast";

import Toast from "../toast/SetToast";

import ProductFileItem from "../Sales/ProductFiles/ProductFileItem";
import PatientCpapFollowupFiles from "./PatientCpapFollowupFiles";
import ProductFileUploadForm from "../Sales/ProductFiles/ProductFileUploadForm";
import { splitCpapFollowupFileDocs } from "../Followup/cpapFollowupFileUtils";
import { isAccessoryOrderItem } from "../../../utils/accessoryLotInventory";
import {
  formatPatientOrderCompletion,
  getPatientOrderItems,
  mergePatientPurchaseOrders,
} from "./patientCpapOrderUtils";
import PatientAnnualMaskBatches from "./PatientAnnualMaskBatches";
import { deleteSaleOrderAttachment } from "../Sales/Orders/saleOrderESlip";
import { loadAnnualMaskCaseDocs } from "../Followup/annualMaskPhysicianQuery";
import {
  ANNUAL_MASK_BATCHES_COLLECTION,
  ANNUAL_MASK_CASES_COLLECTION,
  ANNUAL_MASK_STATUS,
} from "../Followup/annualMaskPurchaseUtils";

const emptyCpapFollowupFiles = {
  usageReports: [],
  questionnaires: [],
};

const getPreviewFileType = (fileName = "") => {
  const fileExtension = String(fileName).split(".").pop().toLowerCase();

  if (
    ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(
      fileExtension,
    )
  ) {
    return "image";
  }

  return "pdf";
};

const ProductCPAP = ({
  profile,
  filesList: allFilesList,
  startAddFile,
  startSetFiles,
  startRemoveFile,
}) => {
  const getSignedUrl = httpsCallable(functions, "getSignedUrl");
  const { currentUser } = useAuth();
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [createModal, setCreateModal] = useState(false);
  const [productId, setProductId] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [cpapinfo, setCpapInfo] = useState("");
  const [cpapOrder, setCpapOrder] = useState(null);
  const [accessoryItems, setAccessoryItems] = useState([]);
  const [fileType, setFileType] = useState(null);
  const [cpapFollowupFiles, setCpapFollowupFiles] = useState(
    emptyCpapFollowupFiles,
  );
  const [cpapFollowupEvents, setCpapFollowupEvents] = useState([]);
  const [cpapFollowupEventsError, setCpapFollowupEventsError] = useState(false);
  const [annualMaskCases, setAnnualMaskCases] = useState([]);
  const filesList = (allFilesList || []).filter((file) => file.hn
    ? file.hn === (profile && profile.hn)
    : Boolean(productId && file.productId === productId));

  const onSubmit = async (formData, files) => {
    if (!isEdit) {
      const data = {
        title: formData.title,
        detail: formData.detail,
        productId,
        hn: profile.hn,
        createBy: currentUser.displayName,
        createAt: new Date(),
      };
      return await startAddFile(data, files);
    } else {
      setIsEdit(false);
    }
  };

  const onDelete = ({ productId: fileProductId, hn, orderId, id }) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          if (hn && orderId) {
            await deleteSaleOrderAttachment({ id: orderId, hn }, currentUser, { hn, id });
            await startSetFiles(productId, { hn: profile.hn });
          } else {
            await startRemoveFile({ productId: fileProductId, hn, id });
          }
          swal("Your file has been deleted!", { icon: "success" });
        } catch (error) {
          notifyError("Cannot delete file. Please try again.");
        }
      } else {
        swal("Canceled");
      }
    });
  };

  const onDownLoad = (productId, id, file) => {
    const attachment = filesList.find((item) => item.id === id);
    getSignedUrl({
      folder: attachment && attachment.hn ? "patientcpapfiles" : "cpapfiles",
      hn: attachment && attachment.hn ? attachment.hn : productId,
      id,
      filename: file,
    })
      .then((result) => {
        fetch(result.data).then((res) => {
          res.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = `${file}`;
            alink.click();
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onViewFile = (productId, id, file) => {
    if (isPreviewLoading) return;
    setIsPreviewLoading(true);
    const attachment = filesList.find((item) => item.id === id);
    getSignedUrl({
      folder: attachment && attachment.hn ? "patientcpapfiles" : "cpapfiles",
      hn: attachment && attachment.hn ? attachment.hn : productId,
      id,
      filename: file,
    })
      .then((result) => {
        setFileUrl(result.data);
        setFileType(getPreviewFileType(file));
        setCreateModal(true);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsPreviewLoading(false);
      });
  };

  const loadPatientCpapFollowupFiles = async (hn) => {
    if (!hn) return emptyCpapFollowupFiles;

    try {
      const filesRef = collection(db, "patients", hn, "cpapFollowupFiles");

      let fileSnap;

      try {
        fileSnap = await getDocs(
          query(filesRef, orderBy("uploadedAt", "desc")),
        );
      } catch (error) {
        fileSnap = await getDocs(filesRef);
      }

      return splitCpapFollowupFileDocs(fileSnap.docs, hn);
    } catch (error) {
      console.error("Load patient CPAP follow-up files error:", error);
      return emptyCpapFollowupFiles;
    }
  };

  const loadPatientCpapFollowupEvents = async (hn) => {
    if (!hn) return { events: [], error: false };
    try {
      const snapshot = await getDocs(query(
        collection(db, "cpap-followup"),
        where("extendedProps.hn", "==", hn),
      ));
      return {
        events: snapshot.docs.map((eventDoc) => ({ ...eventDoc.data(), id: eventDoc.id })),
        error: false,
      };
    } catch (error) {
      console.error("Load patient CPAP follow-up events error:", error);
      return { events: [], error: true };
    }
  };

  const loadPatientAnnualMaskCases = async (hn) => {
    if (!hn) return [];

    try {
      const batchSnapshot = await getDocs(
        collection(db, ANNUAL_MASK_BATCHES_COLLECTION),
      );
      const batchCases = await Promise.all(
        batchSnapshot.docs.map(async (batchDoc) => ({
          batchDoc,
          caseDocs: await loadAnnualMaskCaseDocs(
            collection(
              db,
              ANNUAL_MASK_BATCHES_COLLECTION,
              batchDoc.id,
              ANNUAL_MASK_CASES_COLLECTION,
            ),
            currentUser,
          ),
        })),
      );

      return batchCases
        .reduce(
          (cases, { batchDoc, caseDocs }) =>
            cases.concat(
              caseDocs.map((caseDoc) => {
                const caseData = caseDoc.data();
                return {
                  ...caseData,
                  id: caseDoc.id,
                  batchId: batchDoc.id,
                  refPath: caseDoc.ref.path,
                  batchName:
                    batchDoc.data().batchName || caseData.batchName || "",
                };
              }),
            ),
          [],
        )
        .filter(
          (caseItem) =>
            String(caseItem.hn || "").trim() === String(hn).trim(),
        )
        .sort((left, right) => {
          const leftDate = left.createdAt && left.createdAt.toDate
            ? left.createdAt.toDate().getTime()
            : new Date(left.createdAt || 0).getTime();
          const rightDate = right.createdAt && right.createdAt.toDate
            ? right.createdAt.toDate().getTime()
            : new Date(right.createdAt || 0).getTime();
          return rightDate - leftDate;
        });
    } catch (error) {
      console.error("Load patient Annual Mask Purchase cases error:", error);
      return [];
    }
  };

  const onViewCpapFollowupFile = async (fileData) => {
    if (isPreviewLoading) return;
    setIsPreviewLoading(true);

    try {
      let url = fileData.url || "";

      if (!url && fileData.storagePath) {
        url = await getDownloadURL(storageRef(storage, fileData.storagePath));
      }

      if (!url) {
        notifyWarning("Cannot open this file");
        return;
      }

      setFileUrl(url);
      setFileType(
        getPreviewFileType(fileData.fileName || fileData.storagePath || ""),
      );
      setCreateModal(true);
    } catch (error) {
      console.error("Open CPAP follow-up file error:", error);
      notifyError("Cannot open CPAP follow-up file");
    } finally {
      setIsPreviewLoading(false);
    }
  };

  const handleOnHideModal = () => {
    setCreateModal(false);
    setFileUrl(null);
    setFileType(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const hn = profile && profile.hn;
        const cpapFollowupFilesPromise = loadPatientCpapFollowupFiles(hn);
        const cpapFollowupEventsPromise = loadPatientCpapFollowupEvents(hn);
        const annualMaskCasesPromise = loadPatientAnnualMaskCases(hn);

        if (!hn) {
          setCpapFollowupFiles(await cpapFollowupFilesPromise);
          setAnnualMaskCases(await annualMaskCasesPromise);
          return;
        }

        const orderSnapshots = await Promise.all([
          getDocs(query(
            collection(db, `patients/${hn}/orders`),
            where("activity", "==", "purchase"),
          )),
          getDocs(query(collection(db, "orders"), where("hn", "==", hn))),
          getDocs(query(collection(db, "saleOrders"), where("hn", "==", hn))),
        ]);
        const orders = mergePatientPurchaseOrders(...orderSnapshots.map(
          (snapshot) => snapshot.docs.map((orderDoc) => ({
            ...orderDoc.data(), id: orderDoc.id,
          })),
        ));
        const accessories = [];
        let latestDevice = null;
        orders.forEach((order) => {
          getPatientOrderItems(order).forEach((item, index) => {
            if (isAccessoryOrderItem(item)) {
              accessories.push({ ...item, order, key: `${order.id}-${index}` });
            } else if (!latestDevice && (item.productId || item.productSn)) {
              latestDevice = { item, order };
            }
          });
        });
        setAccessoryItems(accessories);
        setCpapOrder(latestDevice ? latestDevice.order : null);
        const device = latestDevice ? latestDevice.item : {};
        const sn = device.productSn || "";
        let linkedProductId = device.productId || "";
        setSerialNumber(sn);
        setCpapInfo({ brand: device.productBrand, model: device.productName, deviceNo: device.deviceNo });

        const cpapref = query(
          collection(db, "products"),
          where("serialNumber", "==", sn),
        );

        if (sn) await getDocs(cpapref).then((snapshot) => {
          if (!snapshot.empty) {
            snapshot.forEach((childSnapshot) => {
              setCpapInfo(childSnapshot.data());
              linkedProductId = childSnapshot.id;
            });
          }
        });
        setProductId(linkedProductId);
        await startSetFiles(linkedProductId, { hn });

        setCpapFollowupFiles(await cpapFollowupFilesPromise);
        const followupEventsResult = await cpapFollowupEventsPromise;
        setCpapFollowupEvents(followupEventsResult.events);
        setCpapFollowupEventsError(followupEventsResult.error);
        setAnnualMaskCases(await annualMaskCasesPromise);
      } catch (error) {
        console.error("Load patient CPAP data error:", error);
        notifyError("Cannot load patient CPAP data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);


  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={createModal}
        onHide={handleOnHideModal}
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>File</Modal.Title>
          <i
            className="mdi mdi-close"
            onClick={handleOnHideModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
          ></i>
        </Modal.Header>
        <Modal.Body className="m-0 p-0">
          <div
            className="card-body mx-0 p-0 col-lg-12"
            style={{ height: "85vh" }}
          >
            {fileType === "image" ? (
              // Render image with proper fit
              <img
                src={fileUrl}
                alt="File Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              // Render PDF in iframe
              <iframe
                title="CPAP file preview"
                className="col-lg-12 m-0 p-0"
                src={fileUrl + "#toolbar=0"}
                width="100%"
                height="100%"
              ></iframe>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {["super_admin", "admin", "sale", "accountant"].includes(
        currentUser.roles[0],
      ) && (
        <ProductFileUploadForm onSubmit={onSubmit} disabled={isLoading || !(profile && profile.hn)}
          disabledReason={isLoading ? "Loading CPAP details..." : !(profile && profile.hn) ? "A patient HN is required before adding files." : ""} />
      )}
      {!isLoading && (
        <div className="col-12 mb-4">
          <h4 className="mb-3">CPAP Device</h4>
          {cpapOrder ? (
            <div className="table-responsive">
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Sale Order No.</th>
                    <th>CPAP Serial Number</th>
                    <th>Brand</th>
                    <th>Model</th>
                    <th>DeviceNo</th>
                    <th>Status</th>
                    <th>Order Completed Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{cpapOrder.receiptNo || "-"}</td>
                    <td>
                      {serialNumber ? (
                        <Link to={`/product-page/${serialNumber}`}>
                          {serialNumber}
                        </Link>
                      ) : "-"}
                    </td>
                    <td>{cpapinfo.brand || "-"}</td>
                    <td>{cpapinfo.model || "-"}</td>
                    <td>{cpapinfo.deviceNo || "-"}</td>
                    <td>{cpapOrder.status || "-"}</td>
                    <td>{formatPatientOrderCompletion(cpapOrder)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : <p className="text-muted">No CPAP device</p>}
        </div>
      )}
      {!isLoading && (
        <div className="col-12 mb-4">
          <h4 className="mb-3">Accessories</h4>
          {accessoryItems.length ? (
            <div className="table-responsive">
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Sale Order No.</th>
                    <th>Accessory</th>
                    <th>Code</th>
                    <th>Brand</th>
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Status</th>
                    <th>Order Completed Date</th>
                  </tr>
                </thead>
                <tbody>
                  {accessoryItems.map((item) => (
                    <tr key={item.key}>
                      <td>{item.order.receiptNo || "-"}</td>
                      <td>{item.productName || "-"}</td>
                      <td>{item.productSn || "-"}</td>
                      <td>{item.productBrand || "-"}</td>
                      <td>{item.size || "-"}</td>
                      <td>{item.quantity == null ? "-" : item.quantity}</td>
                      <td>{item.order.status || "-"}</td>
                      <td>{formatPatientOrderCompletion(item.order)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : <p className="text-muted">No accessories</p>}
        </div>
      )}
      {!isLoading && (
        <div className="row align-items-stretch">
          <PatientCpapFollowupFiles
            files={cpapFollowupFiles}
            events={cpapFollowupEvents}
            eventsError={cpapFollowupEventsError}
            onViewFile={onViewCpapFollowupFile}
            isPreviewLoading={isPreviewLoading}
          />
          <PatientAnnualMaskBatches
            cases={annualMaskCases}
            currentUser={currentUser}
            onViewFile={onViewCpapFollowupFile}
            isPreviewLoading={isPreviewLoading}
            onUploaded={(uploadedCase, certificate) => {
              setAnnualMaskCases((cases) => cases.map((item) =>
                item.refPath === uploadedCase.refPath ? {
                  ...item,
                  signedMedicalCertificate: certificate,
                  signedCertificateUploadSkip: null,
                  status: ANNUAL_MASK_STATUS.SIGNED_CERTIFICATE_UPLOADED,
                } : item,
              ));
            }}
          />
          <div className="col-12 mb-4 d-flex">
            <ProductFileItem
              files={filesList}
              productId={productId}
              onDelete={onDelete}
              onViewFile={onViewFile}
              onDownLoad={onDownLoad}
              containerClassName="w-100"
              cardClassName="card border-0 pb-0 h-100"
              sectionTitle="Other Files"
            ></ProductFileItem>
          </div>
        </div>
      )}
    </Fragment>
  );
};

// export default PatientReport;
const mapStateToProps = (state, props) => ({
  filesList: selectFiles(state.productFiles),
});

const mapDispatchToProps = (dispatch) => ({
  startSetFiles: (id, patient) => dispatch(startSetFiles(id, "cpapfile", patient)),
  startRemoveFile: (id) => dispatch(startRemoveFile(id)),
  startAddFile: (data, files) => dispatch(startAddFile(data, files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCPAP);
